import React from "react";
import { object, array } from "prop-types";
import { Link } from "@quintype/components";
import "./section-name.m.css";

const SectionName = ({ collection}) => {
  return (
    <div styleName="main-line">
    <Link href={collection.slug} styleName="section-title" className="section-title">{collection.name}</Link>
    <div styleName="line-style"/>
    </div>
  )
}
SectionName.propTypes = {
  collection: object,
};
export {SectionName};
